import { Box, Button, Text } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { Close } from '../../Icons/Close';
import Slider from 'react-slick';
import { Eclipse } from '../../Icons/Eclipse';
import { Forward } from '../../Icons/Forward';
import InstructionItem from '../../components/common/InstructionItem';
import { InstructionsProps } from '../../interfaces/components';
import { Backward } from '../../Icons/Backward';
import { useTranslation } from 'react-i18next';
import BotiqueImg from '../../assets/images/lv_boutique_rule.png';
import CompleteImg from '../../assets/images/complete-game-rule.png';
import HandClick from '../../assets/images/hand_click.png';
import HandMove from '../../assets/images/hand_move.png';
import StampImg from '../../assets/images/lavallee_stamp.png';
import MapIcon from '../../assets/images/map_icon.png';
import MemberImg from '../../assets/images/lv_member_rule.png';
import ServiceImg from '../../assets/images/lv_service_rule.png';
import InstructionRule from '../../components/common/InstructionRule';
import { disptchCTAClickObject } from '../../Analytics';

const Instructions = ({ active, setActive }: InstructionsProps) => {
  const { t } = useTranslation();
  const [activeImageIndex, setActiveImageIndex] = useState({ oldIndex: 0, newIndex: 0 });
  // eslint-disable-next-line
  const sliderRef = useRef<any>();

  const settings = {
    // dots: true,
    // infinite: true,
    initialSlide: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    // autoplay: true,
    // autoplaySpeed: 2000,
    cssEase: 'linear',
    customPaging: (i: number) => (
      <Eclipse
        key={i}
        boxSize={[3, 3, 4]}
        stroke={activeImageIndex.newIndex === i ? '#C29F6B' : '#000'}
        fill={activeImageIndex.newIndex === i ? '#C29F6B' : '#fff'}
        strokeWidth="1px"
        borderRadius="50%"
      />
    ),
    beforeChange: (oldIndex: number, newIndex: number) => {
      setActiveImageIndex({ oldIndex: oldIndex, newIndex: newIndex });
    },
  };

  const onForward = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Instructions', 'forward', '');
    // console.log('Ref', sliderRef.current);
    sliderRef.current.slickNext();
  };

  const onBackward = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Instructions', 'backward', '');
    // console.log('Ref', sliderRef.current);
    sliderRef.current.slickPrev();
  };

  useEffect(() => {
    if (!active) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(0);
      }, 350);
    }
  }, [!active]);

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding={['15px', '15px', '15px', '15px']}
        width={['95vw', '400px', '450px', '510px', '510px']}
        height={
          activeImageIndex.newIndex === 0 ? ['490px', '490px', '520px', '550px'] : ['635px', '635px', '690px', '700px']
        }
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['25px', '25px', '25px']}
          right={['25px', '25px', '25px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box>
          <Slider {...settings} ref={sliderRef}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Text
                textAlign="center"
                fontWeight="400"
                fontSize={['16px', '16px', '18px', '22px', '22px']}
                width="100%"
                mt="10"
                className="copy"
                fontFamily="SangBleuBPLight"
                pt="5"
              >
                {/* How to Expore the Village */}
                {t('instructions-p1-title')}
              </Text>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-around"
                alignItems="center"
                gap={['5', '5', '6']}
                mt="8"
                pb={['10', '5', '10']}
              >
                <InstructionItem Icon={HandClick} text={t('instructions-p1-text1')} />
                <InstructionItem Icon={HandMove} text={t('instructions-p1-text2')} />
                <InstructionItem Icon={MapIcon} text={t('instructions-p1-text3')} />
              </Box>
              <Box mt="3" display="flex" justifyContent="space-between" alignItems="center" p="0px 10px">
                <Box w="60px"></Box>
                <Box display="flex" gap="2">
                  <Eclipse
                    boxSize={[3, 3, 4]}
                    stroke="#C29F6B"
                    fill="#C29F6B"
                    strokeWidth="1px"
                    borderRadius="50%"
                    cursor="pointer"
                  />
                  <Eclipse
                    boxSize={[3, 3, 4]}
                    stroke="#000"
                    fill="#fff"
                    strokeWidth="1px"
                    borderRadius="50%"
                    cursor="pointer"
                    onClick={onForward}
                  />
                </Box>
                <Forward boxSize={['40px', '50px', '60px']} cursor="pointer" onClick={onForward} />
              </Box>
            </Box>

            <Box display="flex" justifyContent="center">
              <Text
                textAlign="center"
                fontWeight="400"
                fontSize={['16px', '16px', '18px', '20px', '20px']}
                width="100%"
                mt={['10', '8', '8', '10']}
                className="copy"
                fontFamily="SangBleuBPLight"
                mb="5"
              >
                {/* Earn Stamps & Get Rewards */}
                {t('instructions-p2-heading')}
              </Text>
              <Box display="flex" flexDir="column" gap="3" alignItems="center" mb="5">
                <InstructionRule image={MemberImg} text={t('instructions-p2-text-one')} />
                <InstructionRule image={ServiceImg} text={t('instructions-p2-text-two')} />
                <InstructionRule image={BotiqueImg} text={t('instructions-p2-text-three')} />
                <InstructionRule image={StampImg} text={t('instructions-p2-text-four')} isStamp />
                <InstructionRule
                  image={CompleteImg}
                  heading={t('instructions-p2-text-five')}
                  text={t('instructions-p2-text-six')}
                />
              </Box>

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                w={['290px', '290px', '310px', '350px', '350px']}
                mx="auto"
              >
                <Box w="60px">
                  <Backward boxSize={['40px', '50px', '60px']} cursor="pointer" onClick={onBackward} />
                </Box>
                <Box display="flex" gap="2">
                  <Eclipse
                    boxSize={[3, 3, 4]}
                    stroke="#000"
                    fill="#fff"
                    strokeWidth="1px"
                    borderRadius="50%"
                    cursor="pointer"
                    onClick={onBackward}
                  />
                  <Eclipse
                    boxSize={[3, 3, 4]}
                    stroke="#C29F6B"
                    fill="#C29F6B"
                    strokeWidth="1px"
                    borderRadius="50%"
                    cursor="pointer"
                  />
                </Box>
                <Button
                  borderRadius="0px"
                  h={['30px', '40px', '40px']}
                  bg="white"
                  border="1px solid gray"
                  onClick={() => setActive()}
                  color="#455255"
                  _hover={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
                >
                  <Text textAlign="center" fontWeight="400" fontSize={['11px', '11px', '12px', '12px', '12px']}>
                    {t('instructions-p2-btn')}
                  </Text>
                </Button>
              </Box>
            </Box>
          </Slider>
        </Box>
      </Box>
    </>
  );
};
export default Instructions;
